export const SORT_TYPE = {
  ASC: 'ASC',
  DESC: 'DESC',
};
